"use strict";

import Common from "./Common";

function CommonGame() {
}
export default CommonGame;

//===================================================
//
// Enumerators
//
//===================================================

// Scene types.
CommonGame.SCENE_ID_MAIN = 0;
CommonGame.SCENE_ID_GAME = 1;
CommonGame.SCENE_ID_IMAGE_SELECTION = 2;
CommonGame.SCENE_ID_GALLERY_SELECTION = 3;

// Layer types.
CommonGame.LAYER_ID_FILL = 0;
CommonGame.LAYER_ID_DRAW = 1;

// Gallery types.
CommonGame.GALLERY_ID_DRAW_IT = 0;
CommonGame.GALLERY_ID_COLOUR_IT = 1;

CommonGame.ARR_COLOUR_IT_SPRITE_ID = [
];

CommonGame.ARR_DRAW_IT_SPRITE_ID = [
];

CommonGame.TUT_EVENT = {
    TOOL_BAR_HIDDEN: 0,
    TOOL_BAR_VISIBLE: 1,
    PALETTE_SELECTED: 2,
    PALETTE_PANEL_HIDDEN: 3,
    TOOL_SELECTED: 4,
    CANVAS_DRAWN: 5,
    CANVAS_VISIBLE: 6,
    PALETTE_BUTTON_ENABLED: 7,
    PALETTE_BUTTON_DISABLED: 8,
    MENU_PANEL_SHOWN: 9,
    MENU_PANEL_HIDDEN: 10
};

CommonGame.TOOL =
{
    PENCIL: 0,
    BRUSH: 1,
    STAMP: 2,
    BUCKET: 3,
    INK_POT: 4,
    SPRAY: 5,
    ERASER: 6
};


//===================================================
//
// Constants
//
//===================================================

CommonGame.GALLERY_BORDER_TINT = [
    0x87d027, // Draw it!
    0x1e84c9 // Colour it!
];

CommonGame.TEXTURE_BUTTON_BASE_ID = "btns_colour_texture";
CommonGame.TEXTURE_SPRITE_BASE_ID = "texture_fill";

CommonGame.CANVAS_HEIGHT = 612;
CommonGame.CANVAS_WIDTH = 870;


//===================================================
//
// Attributes
//
//===================================================

CommonGame.selectedGallery = null;
CommonGame.selectedImageId = null;
CommonGame.drawItTextId = null;

//===================================================
//
// Methods
//
//===================================================

CommonGame.createCanvasBg = function () {
    /*
    var SCALE_FACTOR = 0.979;

    let galleryKey = "drawing";
    if (CommonGame.selectedGallery === 1) galleryKey = "colouring";

    var canvasTex = Common.assets.getTexture("canvas_" + galleryKey);
    var canvasBg = new PIXI.Graphics();
    canvasBg.beginFill(CommonGame.GALLERY_BORDER_TINT[CommonGame.selectedGallery], 1);
    canvasBg.drawRoundedRect(
        -canvasTex.width * 0.5 * SCALE_FACTOR,
        -canvasTex.height * 0.5 * SCALE_FACTOR,
        canvasTex.width * SCALE_FACTOR,
        canvasTex.height * SCALE_FACTOR,
        30);
    canvasBg.endFill();
    */

    //lazy fix
    return new PIXI.Sprite(PIXI.Texture.EMPTY);
};

CommonGame.findColourCode = function (selection) {
    var result = {r: 0, g: 0, b: 1};

    var pages = Common.assets.getJSON("config").palettePanel.pages;
    for (var i = 0; i < pages.length; ++i) {
        var itemIndex = pages[i].indexOf(selection);
        if (itemIndex != -1) {
            result.r = i;
            result.g = itemIndex;

            break;
        }
    }

    return result;
};